import * as Types from '../../../_generated/types.d';

import { GeocodeResponseData } from "@googlemaps/google-maps-services-js";
import { CoachState } from "@portal/app/_common/lib/coach";
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
export type QuestionnaireFlowFragmentFragment = { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> };

export type QuestionnaireFlowQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type QuestionnaireFlowQuery = { __typename?: 'Query', questionnaireFlow: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } };

export const QuestionnaireFlowFragmentFragmentDoc = gql`
    fragment QuestionnaireFlowFragment on QuestionnaireFlowState {
  id
  initialStep {
    id
    name
    status
  }
  steps {
    id
    name
    status
    isBlocking
  }
  hasBlockingStep
}
    ` as unknown as DocumentNode<QuestionnaireFlowFragmentFragment, unknown>;
export const QuestionnaireFlowDocument = gql`
    query questionnaireFlow {
  questionnaireFlow {
    ...QuestionnaireFlowFragment
  }
}
    ${QuestionnaireFlowFragmentFragmentDoc}` as unknown as DocumentNode<QuestionnaireFlowQuery, QuestionnaireFlowQueryVariables>;